import { Flex } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import type { FlexProps } from '@chakra-ui/react'
import type { IconProp } from '@fortawesome/fontawesome-svg-core'

export type IconDiscProps = {
  source: IconProp | string
  size?: string
  color?: string
} & Omit<FlexProps, 'children' | 'minWidth' | 'boxSize' | 'borderRadius' | 'align' | 'justify'>

const IconDisc = ({ source, size = '32px', color, ...props }: IconDiscProps) => {
  return (
    <Flex
      align="center"
      justify="center"
      minWidth={size}
      boxSize={size}
      borderRadius="full"
      background={typeof source === 'string' ? `url(${source})` : (props.background ?? 'unset')}
      {...props}
    >
      {typeof source !== 'string' && <FontAwesomeIcon icon={source} color={color ?? 'black'} />}
    </Flex>
  )
}

export default IconDisc
